import { FabricModel } from './fabric.model';
export class NodeDetailModel {
  constructor(
    public nodeId?: any,
    public nodeName?: string,
    public fabricOption?: FabricModel,
    public inputSensors?: any,
    public outputSensors?: any,
    public selectedInputSensors?: any,
    public selectedOutputSensors?: any,
    public inputSensorCriteria?: any,
    public outputSensorCriteria?: any,
    public load?: any,
    public actionMode?: any,
    //
    public selectedEnity?: any,
    public assignSensor?: boolean,
    public sensorRIdForSelectedEnity?: any,
    public immediateChildNodes?: any,

    //meter
    public meterId?: any,
    public kpiName?: any,
    public monitoredParameter?: any,
    public loadID?: any,
    public level?: any, //entity type
    public selectedLoadEntity?: any
  ) {}
}
